import { render } from "./DriveDesktopAllPhotos.vue?vue&type=template&id=fb1e9948&scoped=true&ts=true"
import script from "./DriveDesktopAllPhotos.vue?vue&type=script&lang=ts"
export * from "./DriveDesktopAllPhotos.vue?vue&type=script&lang=ts"

import "./DriveDesktopAllPhotos.vue?vue&type=style&index=0&id=fb1e9948&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1e9948"]])

export default __exports__